export const LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS = {
	hasDismissedIntroSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
	hasDismissedLiveDocTour: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
	hasDismissedLiveDocModal: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
	hasDismissedContentWrapperTour:
		'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
	hasDismissedAiButtonTour: 'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
	hasDismissedConvertToPageSpotlight:
		'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight',
} as const;

export const LIVE_PAGE_NUDGE = {
	LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
	// used to limit calls to the invite permissions API
	LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible',
} as const;

export const LiveDocsOnboardingKeys = [
	...Object.values(LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS),
	...Object.values(LIVE_PAGE_NUDGE),
] as const;
